import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

/**
 * Presents date widget with year, month and day info.
 *
 * @prop date - Full date (Date, Date string, timestamp)
 * @prop theme - white | gray
 * @prop currentDay - This attribute will be automatically added if it's current day
 */
export default class DateWidget extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    date: { type: Date },
    theme: { type: String, reflect: true },
    currentDay: { type: Boolean, reflect: true },
  };

  constructor() {
    super();
    this.theme = 'white';
    this.date = new Date();
  }

  willUpdate() {
    this.currentDay = this.isDateToday();
    super.willUpdate();
  }

  isDateToday() {
    return this.date.toDateString() === new Date().toDateString();
  }

  /** @internal */
  get dayName() {
    return this.i18n.t(`date.abbr_day_names.${this.dayNameRaw}`);
  }

  /** @internal */
  get monthName() {
    return this.i18n.t(`date.abbr_month_names.${this.month}`);
  }

  /** @internal */
  get year() {
    return this.date.getFullYear();
  }

  /** @internal */
  get month() {
    return this.date.getMonth() + 1;
  }

  /** @internal */
  get day() {
    return this.date.getDate();
  }

  /** @internal */
  get dayNameRaw() {
    return this.date.getDay();
  }

  render() {
    return html`
      <div class="name">${this.dayName}</div>
      <div class="day">${this.day}</div>
      <div class="month">${this.monthName}</div>
      <div class="year">${this.year}</div>
    `;
  }
}

customElements.get('ef-date-widget') ||
  customElements.define('ef-date-widget', DateWidget);
